import { Graph } from "../../framework"
import { initWasmModule } from "../../wasm/wasmModule"
import type { FramePixels } from "../types"

export const create = async <I extends unknown[], O extends unknown[]>(graph: Graph<I, O>) => {
  const wasmModule = await initWasmModule()

  return graph.node<[FramePixels], [number]>({
    process: async (ctx) => {
      const frame = ctx.in(0)
      if (!frame) {
        ctx.out(0, 0)
        return
      }

      const data = frame.data
      const size = data.length * data.BYTES_PER_ELEMENT
      const ptr = wasmModule._malloc(size)
      wasmModule.HEAPU8.set(data, ptr)

      const blurScore = wasmModule.ccall(
        "measure_blur_online",
        "number",
        ["number", "number", "number"],
        [ptr, frame.width, frame.height],
      )

      wasmModule._free(ptr)
      ctx.out(0, blurScore)
    },
  })
}
